const {Component} = require("react");
const PropTypes = require("prop-types");
const Input = require("components/forms/Input");
const {pluckKeysExcept} = require("helpers/object");

class RestrictedInput extends Component {

	static get propTypes() {
		return {
			normalize: PropTypes.func,
			inputComponent: PropTypes.any,
			handleChange: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			inputComponent: Input
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			value: props.value || props.defaultValue || ""
		};
	}

	normalize(value) {
		if (typeof this.props.normalize === "function") {
			return this.props.normalize(value);
		}

		// normalize your value while typing
		return value;
	}

	onInput = (e) => {
		const target = e.target;
		const value = e.target.value;

		this.setState({value: this.normalize(value)}, () => {
			if (value !== this.state.value) {
				if (typeof this.props.onInput === "function") {
					this.props.onInput({target});
				}

				if (typeof this.props.handleChange === "function") {
					this.props.handleChange(this.state.value);
				}
			}
		});
	};

	onChange = (e) => {
		if (typeof this.props.onChange === "function") {
			this.props.onChange(e);
		}
	};

	get inputProps() {
		return pluckKeysExcept(
			this.props,
			Object.keys(this.constructor.propTypes).concat(["onChange", "onInput", "value", "defaultValue"])
		);
	}

	render() {
		const InputComponent = this.props.inputComponent;

		return (
			<InputComponent {...this.inputProps} onChange={this.onChange} onInput={this.onInput} value={this.state.value}>
				{this.renderChildren()}
			</InputComponent>
		);
	}

	renderChildren() {
		return this.props.children;
	}

}

module.exports = RestrictedInput;


// WEBPACK FOOTER //
// ./resources/js/components/forms/RestrictedInput.js